import { make } from 'vuex-pathify';
import { InsuranceManagementService } from '../services/insurance-management.service.js';
import Logger from '@/lib/logger.js';

const service = new InsuranceManagementService();

export const state = {
  insurancePolicies: [],
  totalPolicies: 0
};

export const mutations = {
  ...make.mutations(state)
};

export const actions = {
  async getInsurancePolicies(
    { commit },
    { page, limit, sort, order, search } = {
      page: 1,
      limit: 10,
      sort: '',
      order: '',
      search: ''
    }
  ) {
    try {
      const { data } = await service.getInsurancePolicies(
        page,
        limit,
        order,
        sort,
        search
      );
      commit('SET_INSURANCE_POLICIES', data.insurances);
      commit('SET_TOTAL_POLICIES', data.total);
      return data;
    } catch (error) {
      Logger.error('Fetching Insurance Policies');
      throw error;
    }
  },

  async updateInsurancePolicy({ dispatch }, { id, updates }) {
    try {
      const { data } = await service.updateInsurancePolicy(id, updates);
      dispatch('getInsurancePolicies');
      return data;
    } catch (error) {
      Logger.error('Updating Insurance Policy');
      throw error;
    }
  },

  async createInsurancePolicy({ dispatch }, insurancePolicy) {
    try {
      const { data } = await service.createInsurancePolicy(insurancePolicy);
      dispatch('getInsurancePolicies');
      return data;
    } catch (error) {
      Logger.error('Creating Insurance Policy');
      throw error;
    }
  },

  async deleteInsurancePolicy({ dispatch }, id) {
    try {
      const { data } = await service.deleteInsurancePolicy(id);
      dispatch('getInsurancePolicies');
      return data;
    } catch (error) {
      Logger.error('Delete Insurance Policy');
      throw error;
    }
  }
};

